
function Footer() {
    return (
        <footer className="footer">
            <div className="container">
                <span className="text-muted">&copy; 2024 esVolta </span>
            </div>
        </footer>
    );
}

export default Footer;